module.exports = __webpack_public_path__ + "static/media/purpleCog.09f19497.svg";